import { Form, Spin, Checkbox, Alert, Radio } from "antd";
import { Button as PrimeBtn } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import {
    getFeedbacks,
} from "../../../apis/ProjectApis";
import { confirmDialog } from "primereact/confirmdialog";
import FMLCheckingDialog from "./FMLCheckingDialog";
import { highlightText } from "../../../utils/projectUtils";

const ConfirmImportFPDialog = (props) => {
    const [apiLoading, setApiLoading] = useState(false);
    const toast = useRef(null);
    const [form] = Form.useForm();
    const [feedbackOptions, setFeedbackOptions] = useState([]);
    const project = props.project;
    const [showWarning, setShowWarning] = useState(false);
    const [showCheckBoxes, setShowCheckBoxes] = useState(true);
    const [visibleFMLCheckingDialog, setVisibleFMLCheckingDialog] = useState(false);  

    useEffect(() => {
        if (project) {
            handleGetFeedbacks();
        }
    }, [project]);

    // reset when dialog becomes visible
    useEffect(() => {
        if (props.visible) {
            // clear warnings and reset form values
            setShowWarning(false);
            form.resetFields();
            // fetch latest options for current project (safe even if already fetched)
            if (project && project.id) {
                handleGetFeedbacks();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.visible]);

    const handleGetFeedbacks = () => {
        if (project && project.id) {
            setApiLoading(true);
            getFeedbacks(project.id)
                .then((res) => {
                    if (res.status === 200) {
                        setApiLoading(false);
                        if (props.containsNEN) {
                            setFeedbackOptions(res.data.filter(item => item.feedbackType !== "REWORK").map(item => ({
                                label: item.value,
                                value: item.key,
                            })))
                        } else {
                            setFeedbackOptions(res.data.filter(item => item.feedbackType !== "REWORK" && item.feedbackType !== "AGENDA_GO").map(item => ({
                                label: item.value,
                                value: item.key,
                            })))
                        }

                        //setShowCheckBoxes(res.data.some(item => item.feedbackType === "AGENCY"));

                    } else {
                        toast.current.show({
                            severity: "error",
                            summary: "Status",
                            detail: res.response.data,
                            life: 3000,
                        });
                        setApiLoading(false);
                    }
                })
                .catch((e) => {
                    toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: e,
                        life: 3000,
                    });
                    setApiLoading(false);
                });
        } else {
            toast.current.show({
                severity: "warn",
                summary: "Status",
                detail: "No Selected Project",
                life: 3000,
            });
        }
    };

    const changeVisibleFMLCheckingDialog = (bool) => {
        setApiLoading(false);
        setVisibleFMLCheckingDialog(bool);
    };

    const handleSubmit = () => {
        if (showCheckBoxes === false){
            props.setVisible(false, true);
        }
        form.validateFields().then((values) => {
            let error = false;
            if (feedbackOptions?.length > 0 && values?.generalFeedback?.length !== feedbackOptions?.length) {
                setShowWarning(true);
                error = true;
            } else {
                setShowWarning(false);
            }

            if (error) {
                return;
            }

            if (values?.generalFeedback?.[0] === "GENERAL_AGENDA_GO") {
                confirmDialog({
                    message: (
                        <>
                            Are you sure the m2 is correct?
                            <br />
                            {highlightText(feedbackOptions[0]?.label)}
                        </>
                    ),
                    header: "Confirmation",
                    icon: "pi pi-exclamation-triangle",
                    rejectLabel: "No",
                    acceptLabel: "Confirm",
                    accept: () => {
                        props.setVisible(false, true);
                    },
                    reject: () => {
                        props.setVisible(false, false)
                    }
                });
            } else {
                props.setVisible(false, true);
            }

        })
    }

    return (
        <React.Fragment>
            <Toast ref={toast} />
            <Dialog
                style={{ width: "560px" }}
                header={props?.showTitle ? "This project has already files in the floorplan section, are you sure this project is not yet already created?" : "Confirm Import Floorplanner Project"}
                visible={props.visible}
                onHide={() => { props.setVisible(false) }}
            >
                <Spin spinning={apiLoading} >
                    <React.Fragment>
                        <div className='flex justify-content-between align-items-center'>
                            <Form form={form} onFinish={handleSubmit} >
                                {showWarning && (
                                    <Alert
                                        message="Please select all feedback options before submitting."
                                        type="warning"
                                        showIcon
                                        style={{ marginBottom: "10px" }}
                                    />
                                )}
                                <Form.Item
                                    name="generalFeedback"
                                >
                                    <Checkbox.Group style={{ width: "500px" }}>
                                        {feedbackOptions.map(opt => (
                                            <div
                                                key={opt.value}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    whiteSpace: "pre-line",   // <-- key for \n support
                                                    wordWrap: "break-word",
                                                }}
                                            >
                                                {highlightText(opt.label)}
                                                {opt.value === "FML_CHECKING" && <PrimeBtn
                                                    icon="pi pi-check-square"
                                                    className="p-button-rounded p-button-warning"
                                                    aria-label="FML Checking Error"
                                                    style={{ backgroundColor: "none" }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setVisibleFMLCheckingDialog(true);
                                                    }}
                                                />}
                                                {showCheckBoxes && <Checkbox value={opt.value} />}
                                            </div>
                                        ))}
                                    </Checkbox.Group>
                                </Form.Item>

                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <PrimeBtn
                                        style={{
                                            backgroundColor: "#037eea",
                                            borderColor: "#037eea",
                                            float: "right",
                                            marginRight: "1rem",
                                        }}
                                        type="submit"
                                        label="Confirm import"
                                    />
                                </div>
                            </Form>
                        </div>
                    </React.Fragment>
                </Spin>

            </Dialog>
            <Dialog
                style={{ width: "35vw", height: "30vw" }}
                header="Warnings"
                visible={visibleFMLCheckingDialog}
                onHide={() => {
                    setVisibleFMLCheckingDialog(false);
                }}
            >
                <FMLCheckingDialog
                    project={project}
                    setVisible={changeVisibleFMLCheckingDialog}
                />
            </Dialog>
        </React.Fragment>
    )
}

export default ConfirmImportFPDialog
